import * as fromDatatype from "../datatype-library/index";

export interface bl_wms_grn_processing_queue_RowInterface {
    guid : fromDatatype.GuidDataFieldInterface;
    wms_grn_hdr_guid : fromDatatype.GuidDataFieldInterface;
    wms_grn_line_guid : fromDatatype.GuidDataFieldInterface;
    wms_item_guid : fromDatatype.GuidDataFieldInterface;
    wms_item_code : fromDatatype.VarcharDatatypeInterface;
    fi_item_guid : fromDatatype.GuidDataFieldInterface;
    inv_item_guid : fromDatatype.GuidDataFieldInterface;
    base_bal_qty : fromDatatype.NumericDatatypeInterface;
    uom : fromDatatype.VarcharDatatypeInterface;
    uom_bal_qty : fromDatatype.NumericDatatypeInterface;
    warehouse_guid : fromDatatype.GuidDataFieldInterface;
    namespace : fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    module_guid : fromDatatype.GuidDataFieldInterface;
    applet_guid : fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}

export class bl_wms_grn_processing_queue_RowClass implements bl_wms_grn_processing_queue_RowInterface {
    guid : fromDatatype.GuidDataFieldInterface;
    wms_grn_hdr_guid : fromDatatype.GuidDataFieldInterface;
    wms_grn_line_guid : fromDatatype.GuidDataFieldInterface;
    wms_item_guid : fromDatatype.GuidDataFieldInterface;
    wms_item_code : fromDatatype.VarcharDatatypeInterface;
    fi_item_guid : fromDatatype.GuidDataFieldInterface;
    inv_item_guid : fromDatatype.GuidDataFieldInterface;
    base_bal_qty : fromDatatype.NumericDatatypeInterface;
    uom : fromDatatype.VarcharDatatypeInterface;
    uom_bal_qty : fromDatatype.NumericDatatypeInterface;
    warehouse_guid : fromDatatype.GuidDataFieldInterface;
    namespace : fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    module_guid : fromDatatype.GuidDataFieldInterface;
    applet_guid : fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}